export default __webpack_public_path__ + "static/media/queen_white.7a1aecff.svg";